import React from "react";

const ModalPlaceholder = () => {
  return <div>modal</div>;
};

export default ModalPlaceholder;
